'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhyCantRetractBidPopover = function (_Component) {
    (0, _inherits3.default)(WhyCantRetractBidPopover, _Component);

    function WhyCantRetractBidPopover() {
        (0, _classCallCheck3.default)(this, WhyCantRetractBidPopover);
        return (0, _possibleConstructorReturn3.default)(this, (WhyCantRetractBidPopover.__proto__ || (0, _getPrototypeOf2.default)(WhyCantRetractBidPopover)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhyCantRetractBidPopover, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['id', 'styles']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                styles = _props.styles;

            var whyCantRetractBidPopover = (0, _jsx3.default)(_Popover2.default, {
                id: id,
                bsClass: styles['why-cant-i-retract-bid-popover-text'] + ' popover'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'why_cant_i_retract_bid_popover_text'
            }));
            var whyCantRetractBidOverlay = (0, _jsx3.default)(_OverlayTrigger2.default, {
                container: this,
                trigger: ['click'],
                placement: 'top',
                overlay: whyCantRetractBidPopover,
                rootClose: true
            }, void 0, (0, _jsx3.default)('a', {
                role: 'button',
                tabIndex: '0'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'retract'
            })));
            return whyCantRetractBidOverlay;
        }
    }]);
    return WhyCantRetractBidPopover;
}(_react.Component);

exports.default = WhyCantRetractBidPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popovers/WhyCantRetractBidPopover.js
// module id = hvUq
// module chunks = 46